
import React from "react";
import { CardContent, CardFooter } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import AuthButton from "./AuthButton";
import FormLabel from "./common/FormLabel";
import ErrorAlert from "./alerts/ErrorAlert";
import ExpiredTokenAlert from "./alerts/ExpiredTokenAlert";
import { useForgotPasswordForm } from "@/hooks/auth/useForgotPasswordForm";
import { useTokenExpiryDetection } from "@/hooks/auth/useTokenExpiryDetection";

const ForgotPasswordForm = () => {
  const { 
    email, 
    setEmail,
    loading, 
    errorMessage, 
    success, 
    handleSubmit, 
    handleBackToLogin, 
    handleFormClick 
  } = useForgotPasswordForm();
  
  const { tokenExpired } = useTokenExpiryDetection();

  return (
    <form 
      onSubmit={handleSubmit} 
      className="flex flex-col"
      onClick={handleFormClick}
    >
      <CardContent className="space-y-4 pt-4 pb-4">
        {tokenExpired && <ExpiredTokenAlert />}
        
        <div className="space-y-2">
          <FormLabel htmlFor="reset-email">Email</FormLabel>
          <Input
            id="reset-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@gmail.com"
            required
            className="bg-mono-onyx border-mono-slateGray/30 transition-colors"
            autoComplete="email"
            disabled={loading || success}
          />
          
          {errorMessage && <ErrorAlert message={errorMessage} />}
        </div>
      </CardContent>
      
      <CardFooter className="flex flex-col gap-4 pt-4 pb-8">
        <AuthButton 
          type="submit" 
          loading={loading}
          disabled={success}
        >
          {loading ? "Sending reset link..." : success ? "Link sent" : "Send reset link"}
        </AuthButton>
        
        <div className="flex justify-center mt-2">
          <button
            onClick={handleBackToLogin}
            className="text-mono-seasalt hover:text-mono-platinum transition-colors text-sm"
          >
            Back to login
          </button>
        </div>
      </CardFooter>
    </form>
  );
};

export default ForgotPasswordForm;
